module.exports = __webpack_public_path__ + "static/media/pastoral-care-banner.921c93e2.png";